import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_UNBLOCK_DIGIPAS: MijnRoute = {
    path: 'digipas-deblokkeren',
    navigationEvent: 'toDigipasDeblokkeren',
    regex: /^\/zelf-regelen\/digipas-deblokkeren$/,
    webcomponent: 'mijn-digipas-deblokkeren-webcomponent'
};
